import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { CATEGORY_KEY } from "./keys";

import { CategoryRepository } from "@/repositories/category";

export const useUpdateSubCategoryParentCategories = () => {
  const queryClient = useQueryClient();
  const categoryRepository = useRef(new CategoryRepository());

  return useMutation({
    mutationFn: async ({
      subCategoryId,
      data,
    }: {
      subCategoryId: string;
      data: { categoryIds: string[] };
    }) => {
      return await categoryRepository.current.updateSubCategoryParentCategories(
        subCategoryId,
        data,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate(query) {
          return query.queryKey.includes(CATEGORY_KEY);
        },
      });
    },
  });
};
